import React from 'react'
import { connect } from 'react-redux';
import { TrashIcon } from '@primer/octicons-react';

import { deleteAccess } from '../../actions/accesses';

class DeleteAccessButton extends React.Component {
  handleDelete(event) {
    event.preventDefault()

    const { dispatch, access } = this.props;

    dispatch(deleteAccess(access.uuid));

    event.stopPropagation()
  }

  render() {
    return (
      <button
        className="outline-none mx-2"
        onClick={this.handleDelete.bind(this)}>
        <TrashIcon />
      </button>
    );
  }
}

export default connect()(DeleteAccessButton);
